import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PageLoaderService } from '@hub/services/PageLoader';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NotificationService } from '@hub/services/NotificationService';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { eCurrency, eFrequencyType, eDealPaymentType, eTv10PercentPaymentStatus } from '@hub/generated/enums';
import { LookUps } from '@hub/common/LookUps';
import { BaseComponent } from '@hub/common/BaseComponent';
import { ShowMessages } from '@hub/generated/_messages';
import { PaymentGeneratorModel } from '@hub/models/paymentGenerator.model';

@Component({
  selector: 'payment-schedule-dialog',
  templateUrl: './payment-schedule-dialog.component.html'
})
export class PaymentScheduleDialogComponent extends BaseComponent
  implements OnInit, OnDestroy {

  constructor(
    private fb: FormBuilder,
    public notificationService: NotificationService,
    public pageLoaderService: PageLoaderService,
    public confirmationService: ConfirmationService,
  ) {
    super()
  }

  public formData: FormGroup;

  public visible: boolean = true;
  paymentTypes: SelectItem[];
  frequencyTypes: SelectItem[];
  currencyTypes: SelectItem[];
  isNextClick: boolean = false;
  // editorToolbarButtonOptions: eRcEditorToolbarOptions[] = [eRcEditorToolbarOptions.BOLD, eRcEditorToolbarOptions.UNDERLINE, eRcEditorToolbarOptions.ITALIC, eRcEditorToolbarOptions.TEXTSIZE, eRcEditorToolbarOptions.TEXTCOLOR]

  @Input() data: PaymentGeneratorModel = null;


  @Output() onClose = new EventEmitter();
  @Output() onNext = new EventEmitter();
  @Output() displayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  get display(): boolean {
    return this.visible;
  }

  set display(val) {
    this.visible = val;
    this.displayChange.emit(val);
  }

  ngOnInit() {
    this.inItForm();
    this.setLookups();
  }

  ngOnDestroy() {
  }

  private inItForm() {
    this.formData = this.fb.group({
      paymentCount: [2, Validators.required],
      totalPaymentAmount: [1000, Validators.required],
      commission: [10, Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      currencyType: [eCurrency.USD],
      paymentType: [eTv10PercentPaymentStatus.Paid],
      startDate: [new Date()],
      frequencyType: [eFrequencyType.Monthly],
      description: [],
    });

    this.setFormValues(this.data);
  }

  public setLookups() {
    this.currencyTypes = LookUps.getCurrencyTypes();
    this.paymentTypes = LookUps.getTv10PercentPaymentTypes();
    this.frequencyTypes = LookUps.getFrequencyTypesLu();
  }

  public setFormValues(formData: PaymentGeneratorModel) {

    if (formData) {
      this.formData.patchValue({
        paymentCount: formData.PaymentCount,
        totalPaymentAmount: formData.TotalPaymentAmount,
        commission: formData.Commission,
        currencyType: formData.CurrencyTypeId,
        paymentType: formData.PaymentTypeId,
        startDate: formData.StartDate,
        frequencyType: formData.FrequencyTypeId,
        description: formData.Description,
      });
    }
  }

  public getFormValues(): PaymentGeneratorModel {
    var val = this.formData.value;

    var paymentSchedule = new PaymentGeneratorModel;
    paymentSchedule = {
      PaymentCount: val.paymentCount,
      TotalPaymentAmount: val.totalPaymentAmount,
      Commission: val.commission,
      CurrencyTypeId: val.currencyType,
      PaymentTypeId: val.paymentType,
      StartDate: val.startDate,
      FrequencyTypeId: val.frequencyType,
      Description: val.description,
      PaymentsData: []
    };

    return paymentSchedule;
  }

  onCloseModal() {
    if (!this.isNextClick) {
      this.display = false;
      this.onClose.emit();
    }
  }

  onNextClick() {
    if (this.formData.valid) {
      this.isNextClick = true;
      this.data = this.getFormValues();
      this.onNext.emit(this.data);
    } else {
      this.notificationService.error(ShowMessages.InvalidFormMessage);
    }
  }
}
